import { FixedCard } from "../CommonComponents/DataCard";

function EmployeeDataCard({ employee, onClick }) {
    return (
        <FixedCard width="450px" height="fit-content"
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                cursor: "pointer",
                padding: "1rem"
            }}
            onClick={onClick}
        >
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    width: "100%"

                }}
            >
                <p style={{ flex: 1, textAlign: "center", padding: "1rem", borderRight: "1px solid #ccc", }}>{employee.id}</p>
                <p style={{ flex: 1, textAlign: "center", padding: "1rem", borderRight: "1px solid #ccc", }}>{employee.username}</p>
                <p style={{ flex: 1, textAlign: "center", padding: "1rem", borderRight: "1px solid #ccc", }}>{employee.name}</p>
                <p style={{ flex: 1, textAlign: "center", padding: "1rem", borderRight: "1px solid #ccc", }}>{employee.surname}</p>
                <p style={{ flex: 1, textAlign: "center", padding: "1rem", }}>{employee.jobPosition}</p>
            </div>
        </FixedCard>
    );
}

export default EmployeeDataCard;